import Joi from "joi"

export const RECRUITMENT_FORM_KEYS = {
    OTP: "otp"
}


const jcrOTPRegex =/^[0-9]{6}$/
export const recruitmentOtpSchema = Joi.object({
    [RECRUITMENT_FORM_KEYS.OTP]: Joi.string().label("OTP").required().trim().regex(jcrOTPRegex).messages({
        "string.pattern.base": "\"OTP\" must be a six digit number"
      }),
    
})
